function setErrorMessage(_vm, errors, scroll = false) {
  checkForError(_vm, errors)
  // This method doesn't know what "this" is so we have to pass it in as _vm.
  _vm.showErrorBanner = true
  if(scroll) {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }
}

function getListArray(errors) {
 return  Object.entries(errors)
  .filter(([key, val]) => val.length !== 0 )
  .map(([key, val]) => val);
}

function hasErrors(errors) {
  return Object.keys(errors).length > 0
}

function checkForError(_vm, errors) {
  _vm.message_type = ''
  _vm.message_text = []
  let hasError = hasErrors(errors)

  if (hasError) {
    _vm.message_type = 'error'
    _vm.message_text = getListArray(errors)
  }

  return hasError;
}

export {getListArray, hasErrors, setErrorMessage, checkForError}  

